// extracted by mini-css-extract-plugin
export default {"modalImage":"ImageModal_modalImage__2v4Mf","modalMenu":"ImageModal_modalMenu__qG4IX"};